// local lib
import extractConsolidatedData from './extractConsolidatedData.lib';

const renderConsolidatedInnovationChart = ({company}) => {
  const {data} = extractConsolidatedData({company});
  return !!data?.length && [...data[0].data].some(({y}) => y !== null);
};

export default renderConsolidatedInnovationChart;
